import React, { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import Campaigns from "@/components/Campaigns";
import FreeTrial from "@/components/FreeTrial";
import WhyIona from "@/components/WhyIona";
import SatenYuzGerme from "@/components/SatenYuzGerme";
import SkinAnalysis from "@/components/SkinAnalysis";
import Testimonials from "@/components/Testimonials";
import ReelsSection from "@/components/ReelsSection";
import BlogPreview from "@/components/BlogPreview";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import useSEO from "@/hooks/useSEO";
import { SITE_SEO } from "@/constants/seo";
import { IONA } from "@/constants/site";

export default function LandingPage() {
  useSEO({
    title: SITE_SEO.home.title,
    description: SITE_SEO.home.description,
    canonical: IONA.siteUrl + "/",
    image: IONA.siteUrl + "/services/hero-woman.png",
  });
  useEffect(() => {
    // Handle hash scrolling
    if (window.location.hash) {
      const id = window.location.hash.replace("#", "");
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  }, []);

  return (
    <div data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <ReelsSection />
        <Services />
        <Campaigns />
        <FreeTrial />
        <WhyIona />
        <SatenYuzGerme />
        <SkinAnalysis />
        <Testimonials />
        <BlogPreview />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
